import { UserSuccessModal } from '../user-success-modal';
import { useCareerMotivationModalFacade } from './career-motivation-modal.facade';
import { CareerMotivationModalComponent } from './components';
import type { BaseModalProps } from './types';

export const CareerMotivationModal = ({ onClose, isOpen }: BaseModalProps) => {
  const {
    updateCareerMotivation,
    isOpenUsSuccessModal,
    closeUserSuccessModal,
    handleAfterUpdateCareerMotivation,
    values,
  } = useCareerMotivationModalFacade();

  return (
    <>
      <CareerMotivationModalComponent
        isOpen={isOpen}
        values={values}
        onAfterUpdateCareerMotivation={handleAfterUpdateCareerMotivation}
        onClose={onClose}
        onUpdateCareerMotivation={updateCareerMotivation}
      />
      <UserSuccessModal
        isOpen={isOpenUsSuccessModal}
        utmCampaign="change_motivations_header"
        onClose={closeUserSuccessModal}
      />
    </>
  );
};
